import { useMutation } from '@tanstack/react-query';

import { PluginEquifaxPpsrSerialNumberSearchRequest } from '../../../../types/plugins';
import { handleError, handleSuccess } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { runEquifaxPpsrSerialNumberSearchRequest } from '../../requests/runEquifaxPpsrSerialNumberSearchRequest';

export const useRunEquifaxPpsrSerialNumberSearchRequest = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (data: PluginEquifaxPpsrSerialNumberSearchRequest) =>
      runEquifaxPpsrSerialNumberSearchRequest(constructPost, data),
    onSuccess: () => handleSuccess('Equifax request completed'),
    onError: () => handleError('Equifax request failed'),
  });
  return { runEquifaxPpsrSerialNumberSearchRequest: mutateAsync, ...rest };
};
